// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"NotesList_tableContainer__1tyE3","cell":"NotesList_cell__242TD"};